import {NavigationGuardNext, RouteLocationNormalized} from "vue-router";
import {useAuthStore} from "@/stores/Auth";
import AuthMiddleware from "@/router/middleware/AuthMiddleware";
import {UserRole} from "@/models/UserRole";

/**
 * @note AuthMiddleware must be called before AdminAuthMiddleware!
 */
export default class AdminAuthMiddleware extends AuthMiddleware {
    public async execute(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        try {
            const authStore = useAuthStore();
            const user = await authStore.getUser();
            /*----- verify if user has mandant admin role -----*/
            if (user?.identityRoles?.includes(UserRole.MANDANT_ADMIN)) {
                return true;
            } else {
                // permission denied, redirect to home page
                next({name: "home"});
                return false;
            }
        } catch (error: any) {
            console.error("admin auth error: ", error);
            return false;
        }
    }
}
